
import { useEffect, useState } from "react";
import { Alert, Button, Container, OffcanvasBody, OffcanvasHeader } from "reactstrap";
import styles from "./style.module.scss"
import cx from "classnames";
import DefaultOffCanvas, { DefaultOffCanvasProps } from "../DefaultOffCanvas";
import { OpenChangeDocumentPlazoPubSub, OpenChangeDocumentPlazoPubSubPayload } from "@utils/pubsubs/PubSub";
import { DocumentPlazoChangeDataType } from "@/formTypes/DocumentPlazoChangeDataType";
import ChangeDocumentPlazoForm from "@components/forms/ChangeDocumentPlazoForm";
import { InvoiceApi } from "@/api/InvoiceApi";
import { SettlementApi } from "@/api/SettlementApi";
import LoadingScreen from "@components/content/LoadingScreen";
import { showAlert } from "@utils/Alert";

type ChangeDocumentPlazoOffCanvasProps = {
    onPlazoChanged: (taxChange?: DocumentPlazoChangeDataType) => void
} & DefaultOffCanvasProps

const ChangeDocumentPlazoOffCanvas = (props: ChangeDocumentPlazoOffCanvasProps) => {
    const { btnColor = "primary", className, onPlazoChanged } = props;
    const [defaultData, setDefaultData] = useState<DocumentPlazoChangeDataType>({} as DocumentPlazoChangeDataType);
    const [isOpen, setOpen] = useState(false);
    const [showLoading, setShowLoading] = useState(false);

    useEffect(() => {
        const unsubscribe = OpenChangeDocumentPlazoPubSub.subscribe(openOffCanvas);
        return () => {
            unsubscribe();
        };
    }, []);

    const openOffCanvas = async (payload: OpenChangeDocumentPlazoPubSubPayload) => {
        const { openOffCanvas = false } = payload;
        setOpen(openOffCanvas);
        setDefaultData({
            documentId: payload.documentId,
            documentType: payload.documentType,
            plazo: payload.plazo
        });
    }


    const toogleOffCanvas = (newState: boolean) => {
        setOpen(newState);
        if (newState == false) {
            onCanvasClosed();
        }
    }

    const onCanvasClosed = () => {
        setOpen(false);
    }

    const triggerPlazoChange = (plazoChange?: DocumentPlazoChangeDataType) => {
        try {
            setShowLoading(true);
            if (plazoChange?.documentType == "invoice") {
                InvoiceApi.update(`${plazoChange.documentId}`, { plazo: plazoChange.plazo })
            } else {
                SettlementApi.update(`${plazoChange?.documentId}`, { plazo: plazoChange?.plazo })
            }
            showAlert("success", "El plazo del documento ha sido actualizado correctamente")
            onCanvasClosed()
            if (onPlazoChanged) {
                onPlazoChanged(plazoChange)
            }
        } catch (err) {
            if (err instanceof Error) {
                showAlert("danger", err.message)
            }

        } finally {
            setShowLoading(false);
        }
    }

    return (
        <>
            {props.children && (<Button
                color={btnColor}
                type="button"
                className={cx([className, styles.button])}
                onClick={() => toogleOffCanvas(!isOpen)}
            >
                {props.children}
            </Button>
            )}
            <DefaultOffCanvas
                className={styles.offCanvas}
                direction="end"
                isOpen={isOpen}
                onClosed={onCanvasClosed}
                toggle={() => toogleOffCanvas(!isOpen)}
            >

                <OffcanvasHeader className={styles.offCanvasHeader} toggle={onCanvasClosed}>
                    Ajuste de Plazo de Documento
                </OffcanvasHeader>
                <OffcanvasBody>
                    <Container>
                        <Alert className="mb-4" color="warning">
                            El cambio al plazo se realizara unicamente a este documento
                        </Alert>
                        <ChangeDocumentPlazoForm
                            onPlazoChanged={triggerPlazoChange}
                            defaultData={defaultData}
                        />
                    </Container>
                </OffcanvasBody>
            </DefaultOffCanvas >
            <LoadingScreen isLoading={showLoading} />
        </>
    );
}
export default ChangeDocumentPlazoOffCanvas;
